<template>
  <div class="trigger-mode props-group">
      <el-form-item label="触发方式">
        <el-select v-model="component.properties.openModel">
          <el-option label="弹窗" value="dialog"/>
          <el-option label="新标签页" value="labelPage"/>
        </el-select>
      </el-form-item>
      <el-form-item label="数据来源">
        <el-select v-model="component.properties.link.dataSource">
          <el-option label="外部链接" value="outside"/>
          <el-option label="内部功能" value="inside"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="component.properties.link.dataSource==='outside'" prop="properties.link.external" :rules="{ required: true, message: '请输入链接', trigger: 'change' }">
         <el-input class="outside" v-model="component.properties.link.external"></el-input>
      </el-form-item>
      <div v-if="component.properties.link.dataSource==='inside'">
        <el-form-item label="报表类型" prop="properties.link.reportCategory" :rules="{ required: true, message: '请选择报表类型', trigger: 'change' }">
          <el-select v-model="component.properties.link.reportCategory" @change="changeReportCategory($event, true)">
            <el-option v-for="item in reportCategories" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="选择报表" prop="properties.link.reportId" :rules="{ required: true, message: '请选择报表', trigger: 'change' }">
          <public-combobox ref="publicCombobox" v-model="component.properties.link.reportId" :options="reports" :showOperationLength="10"></public-combobox>
        </el-form-item>
      </div>
  </div>
</template>

<script>
import publicCombobox from '@/components/public/public-combobox.vue'
export default {
  name: 'attr-trigger-mode',
  props: ['component'],
  components: {publicCombobox},
  data () {
    return {
      reportCategories: [{id: 'report', name: '普通报表'}, {id: 'dataSourceReport', name: '辅助报表'}],
      reports: []
    }
  },
  async created () {
    if (this.component.properties.link.reportCategory) {
      await this.changeReportCategory(this.component.properties.link.reportCategory, false)
    }
  },
  methods: {
    getReports () {
      return this.$axios.get('/report-api/report/definition/reports').then((res) => {
        this.reports = res.data
      })
    },
    getDataSourceReport () {
      return this.$axios.get(`/report-api/report/definition/dataSourceReports`).then(res => {
        this.reports = res.data
      })
    },
    async changeReportCategory (val, clear) {
      if (val && clear) {
        this.component.properties.link.reportId = ''
      }
      if (val === 'report') {
        await this.getReports()
      } else if (val === 'dataSourceReport') {
        await this.getDataSourceReport()
      }
    }
  },
  watch: {
    'component.id': function (val) {
      this.reports = []
      if (this.component.properties.link.dataSource === 'inside') {
        this.$nextTick(async () => {
          await this.changeReportCategory(this.component.properties.link.reportCategory, false)
          this.$nextTick(() => this.$refs.publicCombobox && this.$refs.publicCombobox.setOptions(this.component.properties.link.reportId))
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .trigger-mode{
    .outside {
      padding-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/trigger-mode.vue